import React from 'react'
import styles from './Complete.module.css';
import Button from '@mui/material/Button';

const Complete = () => {
  return (
    <section className={styles.complete_area}>
        <h2>Thank you</h2>
        <div className={styles.contents}>
            <h3>お問い合わせありがとうございます。</h3>
            <p>
                ご記入いただいたメールアドレス宛にメールを送信いたしました。<br />
                メールから日程のご調整をお願いいたします。
            </p>
            <div className={styles.btn_wrapper}>
                <Button variant="contained" href='/3daylp/001/'>TOP</Button>
            </div>
        </div>
    </section>
  )
}

export default Complete